Vue.component('streamersNavigation', {
  template: templates.streamersNavigation,
   props: ['role'],
  data() {
    return {
      model: {
        page: 'queues',
        isStreamer: false,
        canAccessEvents: false,
        canAccessTournament: false
      }
    }
  },
   mounted() {
    const c = this;
    if (c.role) {
      c.model.isStreamer = true;
      c.checkFeatureAccess();
    }
  },
  methods: {
    page(page) {
      const c = this;
      c.model.page = page;
      c.$root.$emit('showPage', page);
      console.log(page)
    },
    async checkFeatureAccess() {
      const c = this;
      try {
        // Get minimum tier settings for events and tournaments
        let minEventTier = 2;
        let minTournamentTier = 2;

        try {
          const [eventSettingsResponse, tournamentSettingsResponse] = await Promise.all([
            settingsService.getByKey({ key: 'streamer_event_min_tier' }),
            settingsService.getByKey({ key: 'streamer_tournament_min_tier' })
          ]);

          if (eventSettingsResponse.data && eventSettingsResponse.data.length > 0) {
            minEventTier = parseInt(eventSettingsResponse.data[0].value) || 2;
          }
          if (tournamentSettingsResponse.data && tournamentSettingsResponse.data.length > 0) {
            minTournamentTier = parseInt(tournamentSettingsResponse.data[0].value) || 2;
          }
        } catch (e) {
          // Use defaults if settings not found
        }

        // Get streamer's subscription tier
        const response = await packService.getStreamerPacks();
        if (response.data.subscriptions?.subscriptions?.length > 0) {
          const subscription = response.data.subscriptions.subscriptions[0];
          let streamerTier = 2;

          if (subscription.tier) {
            streamerTier = parseInt(subscription.tier);
          } else if (subscription.subscriptionId) {
            const subId = parseInt(subscription.subscriptionId);
            if (subId === 3) streamerTier = 4;
            else if (subId === 2) streamerTier = 3;
          }

          console.log('Streamer Tier:', streamerTier);
          console.log('Min Event Tier:', minEventTier);
          console.log('Min Tournament Tier:', minTournamentTier);
          console.log(response)

          c.model.canAccessEvents = streamerTier >= minEventTier;
          c.model.canAccessTournament = streamerTier >= minTournamentTier;
        }
      } catch (error) {
        console.warn('Could not check feature access:', error);
        c.model.canAccessEvents = false;
        c.model.canAccessTournament = false;
      }
    }
  }
});

Vue.component('streamers', {
    template: templates.streamers,
    data() {
      return {
        model: {
          
        }
      }
    },
    methods: {
      
    }
});

  